import React from 'react';

import { useForm } from 'react-hook-form';
import { observer } from 'mobx-react';
import { enqueueSnackbar } from 'notistack';

import {
  LbInput,
  LbSelect,
  LbDatePicker,
  YesNoBtnRow,
  HeightInput,
} from '@infoods/lifebase-ui';

import classes from './PersonalInfoWidget.module.scss';
import { ScanIqCustomerPersonalData } from '../../../../../../interfaces/ScanIqCustomerProfileInfo';
import { scanIqCustomerProfileStore } from '../../../../../../stores/scanIqCustomerProfileStore';
import {
  InputBox,
  PhoneNumberInput,
} from '../../../../../../../shared/components/form-components';
import {
  validateAge,
  validateEmail,
} from '../../../../../../../shared/utils/reactHookFormUtils';
import { genderOptions } from '../../../../../../../shared/constants/user-info/gender';

const PersonalInfoWidget = observer(() => {
  const { customerProfileInfo, updateCustomerProfileInfo } = scanIqCustomerProfileStore;

  const { control, handleSubmit } = useForm<ScanIqCustomerPersonalData>({
    values: customerProfileInfo?.personalData,
  });

  const generalInputProps = {
    control,
    size: 'small',
    variant: 'standard',
  } as const;

  const privateInfoProps = { InputProps: { className: 'private-info' } };

  const onSubmit = handleSubmit(async (data) => {
    await updateCustomerProfileInfo(data);

    enqueueSnackbar('Customer profile has been updated successfully.', {
      variant: 'success',
      autoHideDuration: 2000,
    });
  });

  return (
    <form onSubmit={onSubmit} className={classes.container}>
      <InputBox title="Personal Data">
        <LbInput
          {...generalInputProps}
          {...privateInfoProps}
          name="firstName"
          label="First Name"
          rules={{ required: 'First Name is required' }}
        />
        <LbInput
          {...generalInputProps}
          {...privateInfoProps}
          name="lastName"
          label="Last Name"
          rules={{ required: 'Last Name is required' }}
        />
        <LbInput
          {...generalInputProps}
          {...privateInfoProps}
          name="email"
          label="Email"
          rules={{ required: 'Email is required', validate: { validateEmail } }}
        />
        <LbSelect
          {...generalInputProps}
          {...privateInfoProps}
          name="gender"
          label="Gender"
          options={genderOptions}
          rules={{ required: 'Gender is required' }}
        />
        <PhoneNumberInput
          {...generalInputProps}
          {...privateInfoProps}
          name="phone"
          label="Cell Phone"
          rules={{ required: 'Cell Phone is required' }}
        />
        <LbDatePicker
          {...generalInputProps}
          {...privateInfoProps}
          name="dateOfBirth"
          label="Date of Birth"
          helperText="You need to be at least 14 years to join the LifeBase"
          openTo="year"
          rules={{
            required: 'Date of Birth is required',
            validate: { validateMinAge: (value) => validateAge(value, 14) },
          }}
        />
        <HeightInput
          {...generalInputProps}
          {...privateInfoProps}
          name="height"
          label="Height"
          rules={{ required: 'Height is required' }}
        />
      </InputBox>
      <YesNoBtnRow yesText="Save" />
    </form>
  );
});

export { PersonalInfoWidget };
